"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateStatus = void 0;
const role_types_1 = require("./role-types");
const session_activity_types_1 = require("./session-activity-types");
const session_types_1 = require("./session-types");
var EstimateStatus;
(function (EstimateStatus) {
    EstimateStatus["Draft"] = "Draft";
    EstimateStatus["Final"] = "Final";
})(EstimateStatus || (exports.EstimateStatus = EstimateStatus = {}));
//# sourceMappingURL=estimate-types.js.map